import Loadable from 'react-loadable'
const ArtistList = Loadable({
    loader: () => import(/* webpackChunkName: "artists" */ './list'),
    loading: () => null,
})

const ArtistsRoute = ({ location: { state }, match: { params } }) => {
    const { artists } = state
    const { letter } = params
    return <ArtistList artists={artists} filter={letter} />
}

export default ArtistsRoute
